import style from "./Error.module.scss";
import { IError } from "@/types/all.types";
import cn from "classnames";
const Error = ({
  position,
  children,
  className,
  mt,
  mb,
  pl,
  pr,
  flexType,
  color,
  fontWeight,
  bottom
}: IError) => {
  return <div id="error_wrapper" className={cn(style.wrapper, className)} style={{
    "--mt": mt !== undefined ? mt + "px" : "9px",
    "--mb": mb !== undefined ? mb + "px" : "0",
    "--pl": pl !== undefined ? pl + "px" : "0",
    "--pr": pr !== undefined ? pr + "px" : "0",
    "--flexType": flexType ?? "unset",
    "--color": color ? color : "#f25a29",
    "--fontWeight": fontWeight ? fontWeight : 400,
    "--position": position ? position : "relative",
    "--bottom": bottom ? `${bottom}px` : "0"
  } as React.CSSProperties} data-sentry-component="Error" data-sentry-source-file="Error.tsx">
      {children}
    </div>;
};
export default Error;